export default "/images/moova.svg?2fe9f692bc44cacd8a78987fc944133d";